export const retryFunctionNTimes = async <T>(
  promiseFun: () => Promise<T>,
  n: number
): Promise<T> => {
  try {
    return await promiseFun();
  } catch (err) {
    if (n > 0) {
      return await retryFunctionNTimes(promiseFun, n - 1);
    } else {
      throw err;
    }
  }
};
